import React, { useEffect, useState } from "react";
import "./styles.css";
import arrowUp from "../../assets/images/arrow-up-icons.png";
import arrowDown from "../../assets/images/arrow-down-icon.png";
import downloadIcon from "../../assets/images/download-icon.png";
import { useSelector, useDispatch } from "react-redux";
import { setDownloadLink } from "../../reducers/MapSlice";
import useApi from "../../hooks/useApi";
import { getVCITiff } from "../../api/FlaskAPI";
import { setAreaStats } from '../../reducers/MapSlice';
import { CircularProgress } from "@mui/material";

function CollapsibleComponent({
  index,
  child,
  name,
  containerOpen,
  containerClosed,
  headerOpen,
  headerClosed,
  handleDownloadTiff,
  tiffLoading,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [clicked, setclicked] = useState({
    mean: true,
    max: false,
    min: false
  })
  const downloadLink = useSelector((state) => state.mapState.downloadLinks);
  useEffect(() => {
    console.log(name.includes("region"));
  }, []);

  const areas = useSelector((state) => state.mapState.areas);
  const dispatch = useDispatch();

  function handelMax() {
    areas.map((area, index) => {
      console.log(area)
      dispatch(
        setAreaStats({
          polyId: area.polyId,
          data: {
            timestamps: area.data.timestamps,
            stats: area.data.max,
            selected: "max",
            mean: area.data.mean,
            max: area.data.max,
            min: area.data.min,
            unit: area.data.unit
          },
        })
      );
      return area

    })
    setclicked({
      mean: false,
      max: true,
      min: false
    })
  }

  function handelMin() {
    areas.map((area, index) => {
      console.log(area)
      dispatch(
        setAreaStats({
          polyId: area.polyId,
          data: {
            timestamps: area.data.timestamps,
            stats: area.data.min,
            selected: "min",
            mean: area.data.mean,
            max: area.data.max,
            min: area.data.min,
            unit: area.data.unit
          },
        })
      );
      return area
    })
    setclicked({
      mean: false,
      max: false,
      min: true
    })
  }

  function handelMean() {
    areas.map((area, index) => {
      console.log(area)
      dispatch(
        setAreaStats({
          polyId: area.polyId,
          data: {
            timestamps: area.data.timestamps,
            stats: area.data.mean,
            selected: "mean",
            mean: area.data.mean,
            max: area.data.max,
            min: area.data.min,
            unit: area.data.unit
          },
        })
      );
      return area

    })
    setclicked({
      mean: true,
      max: false,
      min: false
    })
  }
  return (
    <div className={`${isOpen ? containerOpen : containerClosed}`}>
      <div className={`${isOpen ? headerOpen : headerClosed}`}>
        {<span style={{ color: "black" }}>{name}</span>}
        {
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          name.includes("Image") ? (
            <a
              onClick={(event) => {
                event.preventDefault();
                if (!tiffLoading) {
                  handleDownloadTiff(index);
                }
              }}
              style={{
                cursor: tiffLoading ? "not-allowed" : "pointer",
                opacity: tiffLoading ? 0.6 : 1,
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {tiffLoading ? (
                <CircularProgress 
                  size={16} 
                  style={{ 
                    color: "black",
                    marginLeft: "15px",
                    marginRight: "15px" 
                  }} 
                />
              ) : (
                <img
                  src={downloadIcon}
                  alt="download"
                  style={{
                    width: "1em",
                    height: "1em",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    right: "0"
                  }}
                />
              )}
            </a>
          ) : (
            <div></div>
          )
        }

        <img
          src={isOpen ? arrowDown : arrowUp}
          style={{
            width: "1em",
            height: "1em",
            cursor: "pointer",
            right: "0"
          }}
          onClick={() => setIsOpen((prev) => !prev)}
        />

        {isOpen && !name.includes("Image") && (
          <div className={"mean-max-min-container"}>
            <span className="mean-max-min-span"
              onClick={handelMean}
              style={clicked.mean ? { scale: "1.5" } : {}}
            >Mean</span>
            <span className="mean-max-min-span"
              onClick={handelMax}
              style={clicked.max ? { scale: "1.5" } : {}}

            >Max</span>
            <span className="mean-max-min-span"
              onClick={handelMin}
              style={clicked.min ? { scale: "1.5" } : {}}

            >Min</span>
          </div>
        )}
      </div>
      {isOpen ? child : <div></div>}
    </div>
  );
}

export default CollapsibleComponent;